/**
 * Created by Ivan on 21.01.2026
 */

const RiddlesMissionViewHorizontal = cc.Node.extend({
    ctor: function (controller, { closeWindowCallback }) {
        this._super();

        this.setAnchorPoint(0.5, 0.5);
        this.setContentSize(cleverapps.resolution.getSceneSize());

        this.mission = controller.mission;
        this.options = controller.options || {};
        this.bundleName = this.options.bundleName || "mission_window";
        this.closeWindowCallback = closeWindowCallback;

        const styles = cleverapps.styles.RiddlesMissionViewHorizontal;

        this.layout = new cleverapps.Layout(this.listContentItems(), {
            direction: cleverapps.UI.VERTICAL,
            margin: styles.margin
        });
        this.addChild(this.layout);
        this.layout.setPosition(this.width / 2, this.height / 2);

        if (this.options.offerWindowButton) {
            this.windowOffer = new WindowOffer(this, Object.assign(this.options.offerWindowButton, {
                positioningStartOffset: this.layout.width / 2
            }));
            this.windowOffer.show();
        }

        if (cleverapps.config.name === "mergecraft") {
            this.persons = new WindowPersons({
                role: "warlock",
                emotion: "happy"
            }, this, [this.layout]);
        }
    },

    listContentItems: function () {
        const styles = cleverapps.styles.RiddlesMissionViewHorizontal;
        const mission = this.mission;

        const table = this.createTable();
        table.setAnchorPoint(0.5, 0.5);

        const titleSlot = this.backgroundSpine.getSlot("slot_title");
        const helpSlot = this.backgroundSpine.getSlot("slot_help");
        const timerSlot = this.backgroundSpine.getSlot("slot_timer");
        const timerBgSlot = this.backgroundSpine.hasSlot("slot_timer_bg") && this.backgroundSpine.getSlot("slot_timer_bg");
        const closeSlot = this.backgroundSpine.hasSlot("slot_close") && this.backgroundSpine.getSlot("slot_close");
        const clockSlot = this.backgroundSpine.getSlot("slot_clock");

        const mainTitle = cleverapps.UI.generateOnlyText(this.options.title || Messages.get(`Missions.${mission.getName()}.Title`), cleverapps.styles.FONTS.RIDDLES_MISSION_HOR_TITLE_TEXT);
        titleSlot.addChild(mainTitle);
        mainTitle.setAlignment(titleSlot.width / 2, titleSlot.height / 2);
        mainTitle.fitTo(titleSlot.width, titleSlot.height);

        const helpButton = new cleverapps.UI.HelpButton({
            type: cleverapps.styles.UI.Button.Images.help_button_transparent,
            callback: () => {
                GuideWindow.createMissionRulesWindow(this.mission);
            }
        });
        helpSlot.addChild(helpButton);
        helpButton.setAlignment(helpSlot.width / 2, helpSlot.height / 2);
        helpButton.setScale(styles.helpButton.scale);
        helpButton.baseScale = helpButton.scale;

        if (closeSlot) {
            const closeButton = this.tableCloseButton = new CloseRoundButton({
                onClicked: this.closeWindowCallback,
                styles: styles.closeButton
            });
            closeSlot.addChild(closeButton);
        }

        if (timerBgSlot) {
            const timerBg = new cc.Scale9Sprite(bundles.timer.frames.timer_bg_png);
            timerBg.setContentSize2(timerBgSlot.getContentSize());
            timerSlot.setLocalZOrder(1);
            timerBgSlot.addChild(timerBg);
            timerBg.setAlignment(timerBgSlot.width / 2, timerBgSlot.height / 2);
        }

        if (mission.isRunning()) {
            let timeLeft = mission.getTimeLeft();
            if (timeLeft > 0) {
                timeLeft = new cleverapps.CountDown(timeLeft, {
                    onFinish: this.closeWindowCallback
                });
            }

            const timer = new cleverapps.CountDownView(timeLeft, {
                font: cleverapps.styles.FONTS.RIDDLES_MISSION_HOR_TIMER_TEXT
            });
            timerSlot.setLocalZOrder(2);
            timerSlot.addChild(timer);
            timer.fitTo(timerSlot.width, timerSlot.height);
            timer.setAlignment(timerSlot.width / 2, timerSlot.height / 2);
        } else {
            const finishTitle = cleverapps.UI.generateOnlyText(this.options.finishedText || Messages.get("Missions.windowFinished"), cleverapps.styles.FONTS.RIDDLES_MISSION_HOR_TIMER_TEXT);
            timerSlot.addChild(finishTitle);
            finishTitle.setAlignment(timerSlot.width / 2, timerSlot.height / 2);
            finishTitle.fitTo(timerSlot.width, timerSlot.height);
        }

        const clock = new cc.Sprite(bundles.timer.frames.timer_png);
        clockSlot.setLocalZOrder(2);
        clockSlot.addChild(clock);
        clock.setPosition(clockSlot.width / 2, clockSlot.height / 2);

        const button = this.createButton();

        return [table, button].filter(Boolean);
    },

    createTable: function () {
        const mission = this.mission;

        const background = this.backgroundSpine = new cleverapps.Spine(bundles[this.bundleName].jsons.mission_board);
        background.setAnimationAndIdleAfter("open", "idle");

        const tableSlot = background.getSlot("slot_table");
        const table = this.mission.runningCompetition.table;
        const tableRowIcon = MissionWindow.GetTableRowIcon(mission.type);
        const tableView = this.tableView = new cleverapps.UI.ScrollView(new cc.Node(), {
            scrollBarEnabled: !table.scrollDisabled,
            mouseScroll: !table.scrollDisabled,
            dock: { toEnd: false }
        });

        new TableHandler(table, tableView, {
            id: mission.type,
            height: tableSlot.height,
            rowConstructor: RiddlesMissionRowView,
            rowOptions: {
                width: tableSlot.width,
                dataIcon: tableRowIcon.icon,
                dataIconAnimation: tableRowIcon.animation,
                dataIconAnimationEffect: tableRowIcon.effect,
                scoreTooltip: Messages.has("KingsCupMissionWindow.tooltip.amount") ? "KingsCupMissionWindow.tooltip.amount" : undefined,
                mission
            }
        });

        if (background.hasSlot("slot_board_bg")) {
            const boardBgSlot = background.getSlot("slot_board_bg");
            boardBgSlot.setLocalZOrder(-1);
            const boardBg = new cc.Scale9Sprite(bundles[this.bundleName].frames.mission_board_bg_png);
            boardBg.setContentSize2(boardBgSlot.getContentSize());
            boardBgSlot.addChild(boardBg);
            boardBg.setAlignment(boardBgSlot.width / 2, boardBgSlot.height / 2);

            boardBgSlot.addChild(tableView);
            tableView.setAlignment(boardBgSlot.width / 2, boardBgSlot.height / 2);
        } else {
            tableSlot.addChild(tableView);
            tableView.setAlignment(tableSlot.width / 2, tableSlot.height / 2);
        }

        const skin = (Mission.GetMissionType(this.mission.type) === Mission.TYPE_EXPEDITION_FEAST ? cleverapps.meta.selectedLocationId() : "")
            + this.mission.getName();

        if (background.hasSkin(skin)) {
            background.setSkin(skin);
        }

        return background;
    },

    createButton: function () {
        const styles = cleverapps.styles.RiddlesMissionViewHorizontal;

        const mission = this.mission;

        if (mission.isRunning() && ["merge", "merge2"].includes(cleverapps.config.type)) {
            return;
        }

        let options = {
            width: styles.button.width,
            height: styles.button.height,
            type: styles.button.red && cleverapps.styles.UI.Button.Images.button_red,
            text: Messages.get("Play").toUpperCase(),

            onClicked: function () {
                this.closeWindowCallback();

                cleverapps.focusManager.distract({
                    focus: "MissionPlayButtonPressed",
                    action: function (f) {
                        Level.WantsToPlay(f);
                    }
                });
            }.bind(this)
        };

        if (!mission.isRunning()) {
            options = Object.assign(options, {
                type: cleverapps.styles.UI.Button.Images.button_green,
                text: Messages.get(mission.getPrize() ? "ClaimPrize.Button.text" : "Close"),
                onClicked: this.closeWindowCallback
            });
        }

        const button = new cleverapps.UI.Button(options);
        button.setAlignment(styles.button);
        button.setVisible(mission.getPrize() && !mission.isRunning());
        return button;
    },

    onResize: function () {
        this.setContentSize(cleverapps.resolution.getSceneSize());
        this.layout.setPosition(this.width / 2, this.height / 2);

        if (this.windowOffer) {
            this.windowOffer.update();
        }

        if (this.persons) {
            this.persons.update();
        }
    },

    onHide: function () {
        if (this.windowOffer) {
            this.windowOffer.hide(true);
        }
    },

    onShow: function () {
        this.mission.runningCompetition.table.showUp();

        if (this.windowOffer) {
            this.windowOffer.show();
        }

        if (this.persons) {
            this.persons.showUp();
        }
    },

    onClose: function () {
        this.mission.runningCompetition.updateShownPlace();
        this.mission.updateMissionIcon();
    }
});

cleverapps.overrideFonts(cleverapps.styles.FONTS, {
    RIDDLES_MISSION_HOR_TITLE_TEXT: {
        size: 90,
        color: new cc.Color(161, 64, 8, 255)
    },

    RIDDLES_MISSION_HOR_TIMER_TEXT: {
        name: "nostroke",
        size: 42,
        color: cleverapps.styles.COLORS.WHITE
    }
});

cleverapps.styles.RiddlesMissionViewHorizontal = {
    margin: -30,

    table: {
        margin: -2
    },

    button: {
        x: { align: "center" },
        y: { align: "center" },
        width: 400,
        height: 110,
        red: true
    },

    helpButton: {
        scale: 1.4
    },

    closeButton: {
        scale: [0.7, 1, 1],
        x: { align: "center" },
        y: { align: "center" }
    }
};
